module.exports = __webpack_public_path__ + "static/media/traffic_bar_bg.ccb60ee1.jpg";